/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';

import { PAGE_FROM_START, pushObdTop } from '../../../router/obd';

import api from '../../../common/api';
import Error from '../../../common/nodejs/errors';
import handler from '../../../share/util/apiResultValidator';
import config from '../../../share/config';
import util from '../../../share/util/utils';
import exam from '../../../share/util/inputValidator';
import alert from '../../../share/alert';
import cstmCard from "../../../share/components/vue/CustomCard";
import svgButton from '../../../share/components/vue/SVGButton';
import customProgress from "../../../share/components/vue/CustomProgress";
import loading from '../../../share/components/vue/ProcessingIcon';
import vehicle from '../../../share/util/vehicle';
import filterDropdown from '../../../share/components/vue/FilterDropdown';
import resource from '../../../share/util/resourceMap';
import diagnoResource from '../../../share/util/diagnose';
import constants from '../../../common/nodejs/constants';
import errorMapping from '../../../share/util/api/errorMapping';
import utils from '../../../share/util/utils';
import authority from '../../../share/util/authorityCheck';
import i18nResourceLoader from '../../../i18n/geti18nLoad';

const areaNameListJson = require('../../../data/executeVinInput/areaNameList.json');
const hiraganaListJson = require('../../../data/executeVinInput/hiraganaList.json');

let modalQueue = [];

const OID_THIRD_PARTY = 'ssm5_third_party_users';

// リプロ仕向け地一覧（SBRリプロ評価者のみ選択可）
const REPRO_REGION_LIST = [
  { text: 'message.common_region_domestic', value: 'Domestic' },
  { text: 'message.common_region_north_america', value: 'NorthAmerica' },
  { text: 'message.common_region_europe', value: 'Europe' }
];

export default {
  emits: ['updateClientHeight', 'closeAppAllModal', 'tapLogout'],
  data() {
    return {
      showConnecterModal: false,
      showIgOnModal: false,
      showVehicleModal: false,
      showVINModal: false,
      showModalQueueWarning: false,
      showStartingObdModal: false,
      showRegionSelectModal: false,
      diagnosisElements: [],
      notification: [],
      appDetails: {
        appVersion: '',
        lastUpdateDate: '',
        appPath: ''
      },
      notificationLoading: false,
      processing: false,
      isLoading: false, // b-overlay用
      fileUrl: null,
      isVehicleDisabled: true,
      vinNumber: '',
      chassisNumber1: '',
      chassisNumber2: '',
      appliedModel: '',
      classificationList: [],
      selectedClassification: '',
      isAlert: { // ページ遷移時の参照エラー対策で初期化する
        vinNumber: { 'msg': "", 'valid': null },
        chassisNumber1: { 'msg': "", 'valid': null },
        chassisNumber2: { 'msg': "", 'valid': null },
        appliedModel: { 'msg': "", 'valid': null },
        classification: { 'msg': "", 'valid': null },
        individualNumber: { 'msg': '', 'valid': null },
        category: { 'msg': '', 'valid': null }
      },
      isCardOpen: true,
      netAppId: '',
      imageSrc: '',
      phaseMessage: '',
      executingIgOn: false,
      isModalQueueRunning: false,
      modalQueueMsg: { lead: '', tail: '' },
      needExitSequence: false,
      hasStackedVinModal: false,
      isVoltChecked: false,
      isExitSequence: false,
      needMoveToMenu: false,
      individualNumber: '',
      category: '',
      isVehicleInspection: false,
      areaNameList: [],
      hiraganaList: [],
      selectedHiragana: '',
      selectedAreaName: '',
      techHqLogin: false,
      modalAlertCgwCecuNotCommunicated: false,
      modalConfirmGetObfcm: false,
      modalErrorDeviceNotSupported: false,
      rprProgress: null, // リプロ車両情報取得有無
      reproRegionList: [],
      selectedReproRegion: 'Domestic', // 仕向け地の選択
      buttonActivateFlg: false
    };
  },

  components: {
    'cstm-card': cstmCard,
    'svg-btn': svgButton,
    'custom-Progress': customProgress,
    'processing-view': loading,
    'filter-dropdown': filterDropdown,
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      isSkipStart: state => state.app.isSkipStart,
      cloudConnectorId: state => state.app.cloudConnectorId,
      lastPairingNetAppId: state => state.userProperty.lastPairingNetAppId,
      enableDownload(state) {
        const group = state.userProperty.oidGroup;
        return !group || group === OID_THIRD_PARTY;
      },
      // クラウドコネクターの接続状況
      pairingStatus: state => state.netAppConnector.status,
      pairingError: state => state.netAppConnector.error,
      pairingWatcher: state => state.netAppConnector.watcher,
      pairingAppId: state => state.netAppConnector.pairingAppId,
      // 車種情報取得の接続状況
      vehicleStatus: state => state.vehicle.status,
      vehicleError: state => state.vehicle.error,
      vehicleWatcher: state => state.vehicle.watcher,
      progress(state) {
        // TODO : 現在はリプロの車両情報取得を実施して診断の車両情報取得するため本処理になっている。
        // 今後、リプロサービスが停止して動作しない場合に診断のみ車両情報取得する場合は本処理を修正する必要がある。
        if (state.vehicle.apiDestination === config.REPRO) {
          // rprの進捗状況を変数管理
          this.rprProgress = state.vehicle.progress;
          const value = state.netAppConnector.isTestMode ? 1 : 2;
          return state.vehicle.progress / value;
        } else if (state.vehicle.apiDestination === config.DIAG) {
          if (!this.rprProgress) return state.vehicle.progress;
          // リプロも車両情報取得している場合はリプロ進捗を50として固定で設定
          return 50 + state.vehicle.progress / 2;
        }
        return state.vehicle.progress;
      },
      vehicleInfo: state => state.vehicle.vehicleInfo,
      apiDestination: state => state.vehicle.apiDestination,
      execType: state => state.vehicle.execType,
      phase: state => state.vehicle.phase,
      warnings: state => state.vehicle.warnings,
      // 車両のキャッシュ情報
      oldVehicleInfo: state => state.cache.vehicleInfo,
      breadCrumbs: state => state.app.breadCrumbs,
      allDtcSystems: state => state.table.allDtcSystems,
      //利用者のcash
      areaInfo: state => state.userProperty.userCache[config.USER_CACHE_REPRO_CHASSIS_AREA_NAME],
      targetUnit: state => state.targetUnit.unitInfo,
      resources: state => state.masterResources.targetUnits,
      userInfo: state => state.userProperty.userInfo,
      isTechnicalHq: state => state.userProperty.userInfo.isTechnicalHq,
      isTestMode: state => state.netAppConnector.isTestMode,
      authGroup: state => state.userProperty.group,
      // 機能の利用可否
      isDiagContainerVisible: state => {
        // 車両情報取得が必要な機能一覧
        const getVehicleInfoFunctionList = [
          config.EXECUE_FUNCTION_TYPE_RPR,
          config.EXECUE_FUNCTION_TYPE_DIAG,
          config.EXECUE_FUNCTION_TYPE_IMMOBILIZER,
          config.EXECUE_FUNCTION_TYPE_MACKKEY,
          config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_DIAG,
          config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA,
          config.FUNCTION_TYPE_OBD
        ];
        const getVehicleInfoAvailable = getVehicleInfoFunctionList.some(
          func => state.userProperty.functionAvailability[func]
        );
        return getVehicleInfoAvailable;
      },
      isDataPlaybackContainerVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_DATAPLAYBACK],
      isReproAvailable: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_RPR],
      isRealWorldDataAvailable: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA],
      isObdAvailable: state => state.userProperty.functionAvailability[config.FUNCTION_TYPE_OBD],
      // 電圧情報有無
      voltage: state => state.vehicle.voltage,
      envActive: state => state.systems.envActive
    }),

    isVinNUmber: {
      get() {
        if (this.vinNumber === '' &&
          this.chassisNumber1 === '' &&
          this.chassisNumber2 === '' &&
          this.appliedModel === '' &&
          this.selectedClassification === '') {
          return true;
        }
        if (this.vinNumber !== '') {
          return true;
        }
        return false;
      }
    },

    isChassisNumber: {
      get() {
        if (this.vinNumber === '' &&
          this.chassisNumber1 === '' &&
          this.chassisNumber2 === '' &&
          this.appliedModel === '' &&
          this.selectedClassification === '') {
          return true;
        }
        if (this.chassisNumber1 !== '' ||
          this.chassisNumber2 !== '' ||
          this.appliedModel !== '' ||
          this.selectedClassification !== '') {
          return true;
        }
        return false;
      }
    },

    isAppliedModelEnabled: {
      get() {
        if (!this.isChassisNumber || this.selectedClassification !== '') {
          return false;
        }
        return true;
      }
    },

    isClassificationEnabled: {
      get() {
        if (!this.isChassisNumber || this.appliedModel !== '') {
          return false;
        }
        return true;
      }
    },

    isVinTypeUnknown: {
      get() {
        if (this.vehicleInfo && this.vehicleInfo.vehicle.vin.type === config.VEHICLEINFO_TYPE_UN_KNOWN) {
          return true;
        }
        return false;
      }
    },

    isClassificationNumberEnabled: {
      get() {
        if (!this.isChassisNumber || !this.isVinTypeUnknown) {
          return false;
        }
        return true;
      }
    },

    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoResource.operationFrom(this.$router.currentRoute.value.name);
    }
  },

  // router prames 対応(isConfirmSkipは使用していない)
  props: ["isAuto"],

  watch: {

    // 表示言語の監視
    language(value) {
      this.updateNoticeInfo(value);

      //CCの画像パスの更新
      this.setCcImageSrc(value);

      // 仕向け地の選択ラジオボタンの更新
      this.getReproRegionList();
    },

    // クラウドコネクターとの接続状態監視
    pairingStatus(value) {

      // 失敗
      if (value === config.POLLING_FAILURE) {
        this.processing = false;
        // 接続失敗の場合は自動接続をOFFに設定しておく
        this.setIsSkipStart(false);
        const error = this.pairingError;
        // APIバリデータの戻りを確認
        if (error.validatorResult) {
          // ネットワーク接続エラーとセッション情報エラーは警告メッセージで表示する
          if (error.validatorResult.causeType === handler.causeTypes.networkError ||
            error.validatorResult.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, error.message, () => {
              if (error.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              }
              else if (error.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
            return;
          }

          // ペアリングに失敗した場合はログアウト処理を実行しない
          if (error.validatorResult.consoleCode === Error.DB_PAIRING_INFO_NOT_FOUND) {
            this.showFailedMessage('message.error_pairing_title', this.pairingError, false);
          }
          else {
            // 警告以外のエラーメッセージの表示
            this.showFailedMessage('message.error_pairing_title', this.pairingError);
          }
        }
        else {
          // バリデータ情報がない場合はエラーメッセージを表示する
          this.showFailedMessage('message.error_pairing_title', this.pairingError);
        }
      }
      // 成功
      else if (value === config.POLLING_COMPLETED) {
        this.processing = false;
        // 自動接続状態の有無をチェック
        if (this.isSkipStart) {
          // 自動で車両情報取得
          this.openConfirmationModalForVehicleInfoAcquisition();
        }
        else {
          const formattedMsg = this.$t('message.message_success_cloud_connect_pairing').replace('####', this.netAppId.trim());
          alert.showSuccess(this, null, formattedMsg);
        }
      }
    },

    // ペアリングIDの監視
    pairingAppId: {
      immediate: true,
      handler(value) {
        // ペアリングIDを監視する
        if (value) {
          // 車両情報取得ボタンを有効化
          this.isVehicleDisabled = false;
        }
        else {
          // ペアリングした情報を初期化
          this.isVehicleDisabled = true;
        }
      }
    },

    // 車種情報取得の状態監視
    async vehicleStatus(value) {

      // 車両情報の取得時には自動接続はOFFに設定しておく
      this.setIsSkipStart(false);

      // 失敗
      if (value === config.POLLING_FAILURE) {
        this.processing = false;
        // 車両情報取得のwait画面を終了
        this.showVehicleModal = false;
        const error = this.vehicleError;
        // APIバリデータの戻りを確認
        if (error.validatorResult) {
          // ネットワーク接続エラーとセッション情報エラーは警告メッセージで表示する
          if (error.validatorResult.causeType === handler.causeTypes.networkError ||
            error.validatorResult.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, error.message, () => {
              if (error.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              }
              else if (error.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
            return;
          }
          // 警告以外のエラーメッセージの表示
          this.showFailedMessage('message.error_vehicle_connect_title', this.vehicleError);
        }
        else {
          // バリデータ情報がない場合はエラーメッセージを表示する
          // デバイス非対応の場合はデバイス非対応エラーメッセージを表示する
          if (!error.deviceSupported) {
            this.modalErrorDeviceNotSupported = true;
            this.resetVehicleState();
          } else {
            this.showFailedMessage('message.error_vehicle_connect_title', this.vehicleError);
          }
        }
        // 車両通信中にエラーが発生したため、CC優先権を破棄し、Start画面に戻る。
        this.leaveCCPriority();
      }
      // 成功
      else if (value === config.POLLING_COMPLETED) {
        /** 初回の単発電圧チェックが完了済みの系 */
        await this.completedVoltCheack();
      }
    },

    async phase(value) {
      // ステータスに応じた文言を設定
      this.phaseMessage = vehicle.getPhaseResources(value, this.phaseMessage, this.apiDestination, this.execType);

      // VIN情報・車台番号が取得できない場合
      if (value === config.COMMUNICATION_UI_VIN_REQUIRED) {
        // battery/rxswin Modal Queue の表示中なら VIN 入力画面はスタック
        if (this.isModalQueueRunning) {
          this.hasStackedVinModal = true;
        } else {
          this.showVinInputModal();
        }
      } else if (value === config.COMMUNICATION_UI_CGW_CECU_NOT_COMMUNICATED) {
        // CGW/C-ECU通信無しの場合
        this.showVehicleModal = false;
        this.modalAlertCgwCecuNotCommunicated = true;
      } else if (value === config.COMMUNICATION_UI_CONFIRM_READ_LEGISLATED_SUPPORT_IDS) {
        if (this.isRealWorldDataAvailable) {
          // リアルワールドデータ手動取得の場合
          this.showVehicleModal = false;
          this.modalConfirmGetObfcm = true;
        } else {
          this.restartConnectionIfRealWorldDataUnavailable();
        }
      }
    },

    warnings(value) {
      if (!value) return;
      // 初回の電圧確認で電圧不足判定なら、vehicle.js 側で stopInterval をするので、
      // ここでは pauseInterval の対象にはならない（すでに watcher インスタンスはないので）
      // よって電圧確認後の車両通信のポーリングの場合のみ、pauseInterval
      if (this.isVoltChecked) this.$pauseInterval(this.vehicleWatcher);
      this.showVehicleModal = false;
      modalQueue = value.split(',');
      this.startModalQueue();
    }
  },

  methods: {
    ...mapActions('app', ['setIsSkipStart']),
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('netAppConnector', ['pairing', 'disconnectPairing']),
    ...mapActions('vehicle', ['updateVehicleInfo', 'updateVin', 'updateVoltage', 'setWarningQueue', 'setStackedWarningQueue', 'setProgress', 'runSystemApi', 'getIndividualMenus', 'continueSystemApi', 'getRealWorldMenus', 'setVehicleProjectId', 'setReproRegion', 'clearVehicleInformation']),
    ...mapActions('cache', ['cacheVehicleInfo', 'cacheDiagProjectList', 'cacheDisplayReproTypeMode']),
    ...mapActions('targetUnit', ['setTargetUnit']),
    ...mapActions('userProperty', ['setUserCache']),
    ...mapActions('table', ['setNativeSystemTable', 'setSystemTblModalFlag', 'getForDisplayMenu']),
    ...mapActions('observation', ['usageCountUp']),
    ...mapActions('immobilizer', ['getImbMenu']),
    ...mapActions('macKey', ['getMacVisibility']),
    ...mapActions(['resetVehicleState']),
    ...mapActions('obd', ['clearObd']),
    // カード開閉時も処理
    cardCollapsed(value) {
      this.isCardOpen = value;
    },

    // お知らせ情報更新処理
    async updateNoticeInfo(language) {

      // お知らせのカードが閉じられている場合は情報を更新しない
      if (!this.isCardOpen) {
        return;
      }

      // 情報の初期化(画面を広く表示するため改行タグを設定)
      this.notification = [{ body: "<br><br><br>" }];
      const params = {
        target: 'notice',
        language: language,
        service: config.SERVICE_REPRO
      };
      this.notificationLoading = true;
      const response = await api.getParamCall(config.ADMIN, '/fileResources', params);
      this.notificationLoading = false;
      handler.validate(
        handler.validateTypes.all,
        response, this, null,
        () => {
          // 処理が成功したときのコールバック処理
          const obj = JSON.parse(response.data.resources);
          if (obj) {
            this.notification = obj.noticeList;
          }

        },
        (result) => {
          // 処理が失敗したときのコールバック処理
          this.notification = [];
          if (result.behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          }
        }
      );
    },

    // クラウドコネクターアプリのダウンロード処理
    async download() {
      // クラウドコネクターダウンロード先パスを初期化
      this.fileUrl = null;
      alert.showConfirmation(this, null,
        this.$t('message.confirm_file_download'),
        async () => {
          this.processing = true;
          // クラウドコネクターの詳細情報を取得
          await this.updateNetAppDetails();
          const filePath = this.appDetails.appPath;
          const params = {
            file_path: filePath
          };
          const response = await api.getParamCall(config.REPRO, '/downloadUrl', params);
          this.processing = false;

          handler.validate(
            handler.validateTypes.all,
            response, this, null,
            () => {
              // 処理が成功したときのコールバック処理
              this.fileUrl = response.data.fileUrl;
            },
            (result) => {
              // 処理が失敗したときのコールバック処理
              if (result.causeType === handler.causeTypes.invalidSessionToken) {
                alert.showWarning(this, null, result.message,
                  () => {
                    this.logout(this);
                  });
              } else {
                alert.showError(this, null, result.message,
                  () => {
                    if (result.behaviorType === handler.behaviorTypes.logout) {
                      this.logout(this);
                    }
                  });
              }
            }, null, false);
        });
    },

    // クラウドコネクタの選択
    async selectCloudConnector() {
      this.netAppId = this.cloudConnectorId;
      this.showConnecterModal = true;
    },
    // ブラウザによって仕様が異なる為現状は、非表示で対応。今後cloudconnecterIDペーストボタンを使用する可能性があるために残しておく
    // Paste clipboard data to cloud connector id
    async pasteCloudConnectorId() {
      try {
        const userAgent = window.navigator.userAgent.toLowerCase();
        let clipboardText = '';
        if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {
          // IE
          clipboardText = window.clipboardData ? window.clipboardData.getData("Text") : "";
        } else {
          // Chrome, Edge
          clipboardText = await window.navigator.clipboard.readText();
        }
        if (clipboardText) {
          this.netAppId = clipboardText;
        }
      } catch (error) {
        // console.log(error)
      }
    },

    // 選択クラウドコネクターとの接続
    async connectToNetApp(netAppId, isNameType) {
      // クラウドコネクターとの接続
      this.processing = true;

      // 現在接続中のクラウドコネクタを切断する
      await this.disconnectPairing({ isDeleteCache: true });

      const data = {
        netAppId: netAppId.trim(),
        isNameType: isNameType,
        this: this
      };
      this.pairing(data);
      this.showConnecterModal = false;
    },
    // 利用者の権限に応じて車両情報取得取得前の確認ダイアログ（仕向け地の選択ダイアログ or IG_ONダイアログ）を開く
    openConfirmationModalForVehicleInfoAcquisition() {
      // SBRリプロ評価者のみ「仕向け地の選択ダイアログ」を表示する
      if (this.authGroup === config.GROUP_SBR_REPRO_TESTER) {
        this.showRegionSelectModal = true;
      } else {
        this.showIgOnDialog();
      }
    },

    /**
     * 「OBDシステム」ボタン押下時に呼ばれるコールバック
     */
    clickObdSystem() {
      //「OBD開始前警告画面」を表示する
      this.showStartingObdModal = true;
    },

    // 車両情報取得(OBD)
    async startConnectionToOBDVehicle() {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        if (this.vehicleInfo?.vehicle.project.id && !this.isTestMode) {
          this.setVehicleProjectId(null);
        }
        // OBDシステム画面へ遷移
        pushObdTop(this, PAGE_FROM_START);
      } else {
        this.showStartingObdModal = false;
      }
    },

    // 車両情報の取得実施直前のIG_ONダイアログ表示
    showIgOnDialog() {
      // SBRリプロ評価者
      if (this.authGroup === config.GROUP_SBR_REPRO_TESTER) {
        // 選択中の仕向け地を保存
        this.setReproRegion(this.selectedReproRegion);
        // 直前に表示していた「仕向け地の選択ダイアログ」を非表示にする
        this.showRegionSelectModal = false;
      }
      this.executingIgOn = false;
      this.showIgOnModal = true;
    },

    // 車両情報の取得
    async startConnectionToVehicle() {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.showIgOnModal = false;
        this.isVoltChecked = false;
        this.isExitSequence = false;
        this.needMoveToMenu = false;
        this.isModalQueueRunning = false;
        // リプロの進捗状況を初期化
        this.rprProgress = null;
        modalQueue = [];
        // 選択中の対象ユニット情報をキャッシュしていると直接 System 画面に
        // 遷移してしまうため、選択中の対象ユニットをクリア
        this.setTargetUnit(null);
        if (!this.pairingAppId) return;
        // Sequence.dllの解放/電圧取得する前は待ちアイコンを表示
        this.processing = true;
        // err_code_list をキャッシュも含めて初期化し、電圧を更新・取得
        this.setWarningQueue('');
        this.setStackedWarningQueue('');

        // リプロサービスの車両情報取得
        await this.updateVoltage({ netAppId: this.pairingAppId, instance: this, type: config.REPRO });
      } else {
        this.showIgOnModal = false;
      }
    },

    async abortSequenceDll() {
      let isSuccess = false;

      try {
        const response = await api.postCall(config.DIAG, `/netApps/${this.pairingAppId}/abortSequenceDll`);
        const isValidResponse = handler.validate(handler.validateTypes.all, response, this, null, null,
          () => {
            // 失敗した場合
            // abortSequenceDll()の呼び元でエラーダイアログを表示するためここではログアウトしない
            /*if (result.behaviorType === handler.behaviorTypes.logout) {
              this.logout(this);
            }*/
          }, null, false);

        if (isValidResponse) {
          isSuccess = await this.getPollingAbortSequenceDll();
        }
      } catch (error) {
        // noop
      }

      return isSuccess;
    },

    async getPollingAbortSequenceDll() {
      await util.sleep(config.WAIT_DB_EVENT_TIME);

      let currentRetry = 0;
      let isSuccess = false;
      const retryCount = Number(process.env.VUE_APP_VEHICLE_RETRY_COUNT);
      const polling = async () => {
        return new Promise((resolve) => {
          const watcher = this.$startInterval(async () => {
            const response = await api.getCall(config.DIAG, `/pairings/${this.pairingAppId}`);
            handler.validate(handler.validateTypes.all, response, this, null,
              () => {
                // 成功した場合
                if (response.data.is_net_app_checking_completed) {
                  isSuccess = true;
                  this.$stopInterval(watcher);
                  resolve();
                  return;
                }
                // リトライ上限超過
                if (++currentRetry === retryCount) {
                  this.$stopInterval(watcher);
                  resolve();
                  return;
                }
              }, (result) => {
                // 失敗した場合
                this.$stopInterval(watcher);
                if (result.behaviorType === handler.behaviorTypes.logout) {
                  this.logout(this);
                }

                resolve();
                return;
              }, null);
          }, Number(process.env.VUE_APP_VEHICLE_RETRY_INTERVAL), 'getPollingAbortSequenceDll');
        });
      };

      await polling();
      return isSuccess;
    },
    cancelIgnition() {
      this.showIgOnModal = false;
      if (this.authGroup === config.GROUP_SBR_REPRO_TESTER) {
        this.showRegionSelectModal = true;
      }
    },

    // クラウドコネクタの詳細情報取得
    async updateNetAppDetails() {
      try {
        const response = await api.getCall(config.REPRO, '/netApps');
        handler.validate(
          handler.validateTypes.all, response, this, null,
          () => {
            // 成功した場合
            this.appDetails.appVersion = response.data.version;
            this.appDetails.lastUpdateDate = util.timeConverter(response.data.last_update_time);
            this.appDetails.appPath = response.data.path;
          },
          (result) => {
            // 失敗した場合
            if (result.behaviorType === handler.behaviorTypes.logout)
              this.logout(this);
          }, null);
      } catch (error) {
        // console.log(error);
      }
    },

    async completedVoltCheack() {
      this.processing = false;
      const systemMode = vehicle.getVehicleSystemMode(this.isTestMode, this.isTechnicalHq);

      if (!this.isVoltChecked) {
        /** 初回の単発電圧チェックが完了していない系 */
        this.clearWatcher();        // 電圧更新側のポーリング用 watcher を削除
        this.isVoltChecked = true;  // 車両通信の開始に十分な電圧があることを確認
        if (!this.pairingAppId) return;

        // 車両通信の開始、vehicle モジュール側で車両情報全更新用の watcher が新規に登録される
        this.phaseMessage = vehicle.getPhaseResources(config.COMMUNICATION_UI_VEHICLE_OBD, null, this.apiDestination, this.execType);
        this.showVehicleModal = true;
        this.isExitSequence = false;
        this.updateVehicleInfo({
          netAppId: this.pairingAppId,
          endPoint: '',
          this: this,
          type: config.REPRO,
          // isRxswinUpdateFlow: Start 画面の車両通信で RxSWIN 更新完了ダイアログを表示させるフラグ
          // isCreateProject: システムAPI実施前にプロジェクト作成APIを投げるか否かのフラグ
          options: { isRxswinUpdateFlow: true, isCreateProject: true }
        });
      } else {
        /** 初回の単発電圧チェックが完了済みの系 */
        if (this.isModalQueueRunning) {
          // まだ表示中の 電圧・RxSWIN 警告ダイアログがあるので Menu 画面に遷移しない
          // 再帰呼び出しの警告ダイアログすべてを閉じたときに Menu 画面に遷移させるフラグを ON
          this.needMoveToMenu = true;
        } else {
          // TODO : 現在はリプロの車両情報取得を実施して診断の車両情報取得するため本処理になっている。
          // 今後、リプロサービスが停止して動作しない場合に診断のみ車両情報取得する場合は本処理を修正する必要がある。
          if (this.apiDestination === config.REPRO) {
            if (this.isTestMode) {
              // テストモードの際はメニュー画面へ遷移処理を実施
              await this.transitionMenuScreenHandler(systemMode);
              return;
              // SSM5対象外車両の場合はメニュー画面へ遷移処理を実施
            } else if (!this.vehicleInfo.is_ssm5_supported) {
              await this.transitionMenuScreenExcludedVehicle(systemMode);
              return;
            }
            if (this.isTestMode) {
              // メニュー画面へ遷移処理を実施
              await this.transitionMenuScreen(systemMode);
              return;
            }
            // 診断情報取得
            await this.diagVehicleInfo();
          } else {
            // メニュー画面へ遷移処理を実施
            await this.transitionMenuScreenHandler(systemMode);
          }
        }
      }
    },

    //技本専用アカウントへ遷移
    async moveToTechHqLogin() {
      this.processing = true;
      const accessUrl = process.env.VUE_APP_PHASE1_URL;
      await this.logout(this);
      this.processing = false;
      window.location.href = accessUrl + '/?autologin=true';
    },

    // VIN(車両番号)情報の検証
    validate() {
      // 検証結果キャッシュの初期化
      const resultPool = [];
      this.clearAlert();

      if (this.isVinNUmber) {
        // VINの検証
        this.isAlert.vinNumber = exam.excuteValidateCommons(this.vinNumber, true, config.VEHICLEINFO_VIN_MAX_LEN, config.VEHICLEINFO_VIN_MAX_LEN, config.VEHICLEINFO_VIN_PATTERN);
        resultPool.push(this.isAlert.vinNumber.valid, this.isAlert.vinNumber.characterNumber);
      } else {
        // 車台番号１の検証
        this.isAlert.chassisNumber1 = exam.excuteValidateCommons(this.chassisNumber1, true, config.VEHICLEINFO_CHASSIS_NUMBER1_MAX_LEN, config.VEHICLEINFO_CHASSIS_NUMBER1_MAX_LEN, config.VEHICLEINFO_CHASSIS_NUMBER1_PATTERN);
        resultPool.push(this.isAlert.chassisNumber1.valid);
        // 車台番号２の検証
        this.isAlert.chassisNumber2 = exam.excuteValidateCommons(this.chassisNumber2, true, config.VEHICLEINFO_CHASSIS_NUMBER2_MAX_LEN, config.VEHICLEINFO_CHASSIS_NUMBER2_MAX_LEN, config.VEHICLEINFO_CHASSIS_NUMBER2_PATTERN);
        resultPool.push(this.isAlert.chassisNumber2.valid);
        // 個別番号の検証
        this.isAlert.individualNumber = exam.excuteValidateCommons(this.individualNumber, false, 0, 128);
        resultPool.push(this.isAlert.individualNumber.valid);
        // 分類番号の検証
        this.isAlert.category = exam.excuteValidateCommons(this.category, false, 0, 128);
        resultPool.push(this.isAlert.category.valid);
        // アプライドモデルの検証
        if (this.isVinTypeUnknown) {
          this.isAlert.appliedModel = exam.excuteValidateCommons(this.appliedModel, true, config.VEHICLEINFO_APPLIED_MODEL_MAX_LEN, config.VEHICLEINFO_APPLIED_MODEL_MAX_LEN, config.VEHICLEINFO_APPLIED_MODEL_PATTERN);
        } else {
          if (this.appliedModel === '' && this.selectedClassification === '') {
            this.isAlert.classification = { valid: false, msg: 'message.alert_validate_partial_required' };
            this.isAlert.appliedModel = { valid: false, msg: 'message.alert_validate_partial_required' };
            resultPool.push(this.isAlert.classification.valid);
          } else {
            if (this.appliedModel) {
              this.isAlert.appliedModel = exam.excuteValidateCommons(this.appliedModel, true, config.VEHICLEINFO_APPLIED_MODEL_MAX_LEN, config.VEHICLEINFO_APPLIED_MODEL_MAX_LEN, config.VEHICLEINFO_APPLIED_MODEL_PATTERN);
            }
          }
        }
        resultPool.push(this.isAlert.appliedModel.valid);
      }

      const faults = resultPool.filter(el => el === false);
      return faults.length === 0;
    },

    clearAlert() {
      this.isAlert = {
        vinNumber: { valid: null, msg: '' },
        chassisNumber1: { valid: null, msg: '' },
        chassisNumber2: { valid: null, msg: '' },
        appliedModel: { valid: null, msg: '' },
        classification: { valid: null, msg: '' },
        individualNumber: { valid: null, msg: '' },
        category: { valid: null, msg: '' },
      };
    },

    // VIN(車両番号)の更新処理
    async updateVinNumber() {
      // 入力の検証
      if (!this.validate()) return;

      let vin = null;
      let type = null;
      let appliedModel = null;
      let classification = null;
      let hiragana = null;
      let areaName = null;
      let category = null;
      let individualNumber = null;
      let isVehicleInspection = null;

      // VIN番号入力が有効な場合
      if (this.isVinNUmber) {
        vin = this.vinNumber;
        type = config.VEHICLEINFO_TYPE_VIN;
      }
      else {
        // 車両番号入力が有効な場合
        vin = this.chassisNumber1 + '-' + this.chassisNumber2;
        type = config.VEHICLEINFO_TYPE_CHASSISNUMBER;
        appliedModel = this.appliedModel;
        classification = this.selectedClassification;
        hiragana = this.selectedHiragana;
        areaName = this.selectedAreaName;
        category = this.category;
        individualNumber = this.individualNumber;
        isVehicleInspection = this.isVehicleInspection;
        // //Userが最後に選択した地域名を保持
        this.setUserCache({ key: config.USER_CACHE_REPRO_CHASSIS_AREA_NAME, value: areaName });
      }

      const param = {
        vehicle: {
          vin: {
            vin: vin,
            type: type,
            applied_model: appliedModel,
            classification: classification,
            hiragana: hiragana,
            area_name: areaName,
            category: category,
            individual_number: individualNumber,
            is_vehicle_inspection: isVehicleInspection,
            is_vin_manual_input: true
          }
        }
      };

      const data = {
        this: this,
        netAppId: this.pairingAppId,
        params: param,
        hiragana: hiragana,
        area_name: areaName,
        category: category,
        individual_number: individualNumber,
        is_vehicle_inspection: isVehicleInspection
      };
      this.isLoading = true;
      // VIN情報と車台番号情報を更新
      const result = await this.updateVin(data);
      this.isLoading = false;
      this.showVINModal = false;

      // 正常終了か確認
      if (result.status === config.POLLING_COMPLETED) {
        // VIN情報を再取得した状態を内部で再キャッシュ
        this.cacheVehicleInfo(this.vehicleInfo);
        // VIN 入力ダイアログを閉じて車両通信ポーリングを再開
        this.showVehicleModal = true;
        this.$resumeInterval(this.vehicleWatcher);
      }
      else {
        this.$stopInterval(this.vehicleWatcher);
        // 成功以外の場合はエラーを表示する
        this.showFailedMessage('message.error_update_vin_numeber', result.error);
      }
    },

    // VIN(車両番号)ダイアログのキャンセルイベント
    closeVinModal() {
      this.$stopInterval(this.vehicleWatcher);
      this.showVINModal = false;
      // VIN（車台番号）の入力をキャンセルした場合、CC優先権を破棄し、Start画面に戻る。
      this.leaveCCPriority();
    },

    /**
     * CGW/C-ECU通信無し警告ダイアログからの車両通信ポーリングの再開処理
     */
    async restartConnectionToVehicle() {
      const data = {
        this: this,
        netAppId: this.pairingAppId,
        requestBody: {
          type: constants.VEHICLE_CONTINUE_CHECK_SYSTEM_TYPE_CGW_CECU_NOT_COMMUNICATED
        }
      };
      this.processing = true;
      // SystemsAPIのCGWサポートチェック後の処理を実行
      const isSuccess = await this.continueSystemApi(data);
      this.processing = false;

      // 正常終了か確認
      if (isSuccess) {
        // CGW/C-ECU通信無し警告ダイアログを閉じて車両通信ポーリングを再開
        this.modalAlertCgwCecuNotCommunicated = false;
        this.showVehicleModal = true;
        this.$resumeInterval(this.vehicleWatcher);
      }
      else {
        // ポーリングの停止
        this.$stopInterval(this.vehicleWatcher);
      }
    },

    /**
     * CGW/C-ECU通信無し警告ダイアログのキャンセルイベント
     */
    closeCGwNotConnectModal() {
      this.$stopInterval(this.vehicleWatcher);
      this.modalAlertCgwCecuNotCommunicated = false;
      // CGW/C-ECU無応答で車両情報取得をキャンセルした場合、CC優先権を破棄し、Start画面に戻る。
      this.leaveCCPriority();
    },

    /**
     * リアルワールドデータ取得確認ダイアログからの車両通信ポーリングの再開処理（リアルワールドデータ サポートPID取得実行）
     * @param {*} isConsentObfcm true: OKボタン押下、false: キャンセルボタン押下
     */
    async getObfcmToVehicle(isConsentObfcm) {
      const data = {
        this: this,
        netAppId: this.pairingAppId,
        requestBody: {
          type: constants.VEHICLE_CONTINUE_CHECK_SYSTEM_TYPE_GET_OBFCM,
          is_consent_obfcm: isConsentObfcm
        }
      };
      this.processing = true;
      // SystemsAPIのCGWサポートチェック後の処理を実行
      const isSuccess = await this.continueSystemApi(data);
      this.processing = false;

      // 正常終了か確認
      if (isSuccess) {
        // リアルワールドデータ取得確認ダイアログを閉じて車両通信ポーリングを再開
        this.modalConfirmGetObfcm = false;
        this.showVehicleModal = true;
        this.$resumeInterval(this.vehicleWatcher);
      }
      else {
        // ポーリングの停止
        this.$stopInterval(this.vehicleWatcher);
      }
    },

    /**
    * 車両通信ポーリングの再開処理（個車情報取得の機能プランが利用不可の場合、OBFCM取得しない）
    */
    async restartConnectionIfRealWorldDataUnavailable() {
      const data = {
        this: this,
        netAppId: this.pairingAppId,
        requestBody: {
          type: constants.VEHICLE_CONTINUE_CHECK_SYSTEM_TYPE_GET_OBFCM,
          is_consent_obfcm: false
        }
      };
      // SystemsAPIのCGWサポートチェック後の処理を実行
      const isSuccess = await this.continueSystemApi(data);

      // 正常終了か確認
      if (isSuccess) {
        // 車両通信ポーリングを再開
        this.$resumeInterval(this.vehicleWatcher);
      }
      else {
        // ポーリングの停止
        this.$stopInterval(this.vehicleWatcher);
      }
    },

    //地域名/ひらがなJsonファイル書き出し
    readJsonFile(jsonFlie) {
      const jsonFile = [];
      const jsonParseFlie = JSON.parse(JSON.stringify(jsonFlie));
      for (let index = 0; index < jsonParseFlie.length; ++index) {
        jsonFile[index] = jsonParseFlie[index];
      }
      return jsonFile;
    },

    //選択された地域名を変数に設定する
    dropdownSelectedAreaName: function (param) {
      if (param.name) {
        this.selectedAreaName = param.name;
      }
      else {
        if (this.areaInfo) {
          this.selectedAreaName = this.areaInfo;
          this.$nextTick(() => {
            this.$refs.fltdlpAreaName.reset(this.areaInfo);
          });
        }
        else {
          this.selectedAreaName = this.areaNameList[0].name;
          this.$nextTick(() => {
            this.$refs.fltdlpAreaName.reset(this.selectedAreaName);
          });
        }
      }
    },

    //選択されたひらがなを変数に設定する
    dropdownSelectedHiragana: function (param) {
      if (param.name) {
        this.selectedHiragana = param.name;
      }
      else {
        this.selectedHiragana = this.hiraganaList[0].name;
        this.$nextTick(() => {
          this.$refs.fltdlpHirgana.reset(this.selectedHiragana);
        });
      }
    },

    // エラーメッセージ表示処理
    showFailedMessage(errTitleId, errorInfo, isLogout = true) {
      const error = errorInfo;
      // メンテナンスエラーの場合はエラー表示を変更する
      let messages = null;
      if (!error.validatorResult || error.validatorResult.causeType === handler.causeTypes.maintenanceError) {
        messages = error.message;
      }
      else {
        const errTitle = this.$t(errTitleId);
        messages = {
          mainMessage: errTitle,
          messageList: []
        };
        const messageFirst = {
          label: this.$t('message.common_label_error_message'),
          message: error.message
        };
        messages.messageList.push(messageFirst);
      }

      alert.showError(this, null, messages, () => {
        if (error.behaviorType === handler.behaviorTypes.logout) {
          if (isLogout) {
            this.logout(this);
          }
        }
      });
    },

    setCcImageSrc(lang) {
      switch (lang) {
        case 'ja':
          this.imageSrc = require('@/assets/img/ja_v236.png');
          break;
        case 'en':
          this.imageSrc = require('@/assets/img/en_v236.png');
          break;
        case 'zh':
          this.imageSrc = require('@/assets/img/zh_v236.png');
          break;
        case 'it':
          this.imageSrc = require('@/assets/img/it_v236.png');
          break;
        case 'es':
          this.imageSrc = require('@/assets/img/es_v236.png');
          break;
        case 'fr':
          this.imageSrc = require('@/assets/img/fr_v236.png');
          break;
        case 'de':
          this.imageSrc = require('@/assets/img/de_v236.png');
          break;
        case 'ru':
          this.imageSrc = require('@/assets/img/ru_v236.png');
          break;
        default:
          this.imageSrc = require('@/assets/img/en_v236.png');
          break;
      }
    },

    // //車検証無しのcheck
    checkboxChanged: function (ischecked) {
      if (ischecked === true) {
        this.$refs.fltdlpAreaName.reset('-');
        this.$refs.fltdlpHirgana.reset('Z');
        this.selectedHiragana = 'Z';
        this.selectedAreaName = '-';
        this.individualNumber = '9999';
        this.category = '99';
      }
      else {
        this.$refs.fltdlpAreaName.reset(this.areaNameList[0].name);
        this.$refs.fltdlpHirgana.reset(this.hiraganaList[0].name);
        this.selectedHiragana = this.hiraganaList[0].name;
        this.selectedAreaName = this.areaNameList[0].name;
        this.individualNumber = '';
        this.category = '';
      }
    },

    // プロジェクト一覧画面へ遷移
    moveToDiagProjects: function () {
      // データ再生のカウントを1つ加算する
      this.usageCountUp({ type: config.USAGE_COUNT_DATA_PLAYBACK });
      this.$router.push({ name: 'diagProjectList' });
    },

    startModalQueue: async function () {
      if (modalQueue.length > 0) {
        this.processing = false;
        this.isModalQueueRunning = true;
        this.modalQueueMsg = { lead: '', tail: '' };
        // RxSWIN 読込みで発生するエラーだけは Frontend で表示文言を引き当てる特殊対応
        const msgConfig = resource.getRxswinErrorMessageSet(modalQueue[0]);
        this.modalQueueMsg.lead = msgConfig.lead ? this.$t(msgConfig.lead) : '';
        this.modalQueueMsg.tail = msgConfig.tail ? this.$t(msgConfig.tail) : '';
        // 初回電圧確認のエラーコード 4300 の場合だけ「終了」ボタンを表示
        this.needExitSequence = (modalQueue[0] === '4300') && !this.isVoltChecked;
        this.showModalQueueWarning = true;
      } else {
        this.isModalQueueRunning = false;
        // Vuex の Modal Queue 初期化
        this.modalQueueMsg = { lead: '', tail: '' };
        // 車両通信が完了している場合は Vehicle 画面に遷移
        if (this.needMoveToMenu) {
          const systemMode = vehicle.getVehicleSystemMode(this.isTestMode, this.isTechnicalHq);
          // TODO : 現在はリプロの車両情報取得を実施して診断の車両情報取得するため本処理になっている。
          // 今後、リプロサービスが停止して動作しない場合に診断のみ車両情報取得する場合は本処理を修正する必要がある。
          if (this.apiDestination === config.REPRO) {
            // 診断情報取得画面に遷移
            this.showVehicleModal = true; // 警告ダイアログ表示後showVehicleModalが閉じたままになってしまうので、ダイアログ立ち上げる
            await this.diagVehicleInfo();
          } else {
            // メニュー画面へ遷移処理を実施
            await this.transitionMenuScreenHandler(systemMode);
          }
          return;
        }
        // 初回電圧確認で電圧が不足していても車両通信の開始は可能
        // その場合は Modal Queue をすべて閉じた段階で、電圧確認が完了したと見なす
        if (!this.isVoltChecked) {
          this.processing = false;
          this.isVoltChecked = true;
          // 車両通信の終了ボタンが押下されていなければ車両通信の開始
          // vehicle モジュール側で車両情報全更新用の watcher が新規に登録される
          if (!this.pairingAppId) return;
          if (!this.isExitSequence) {
            this.showVehicleModal = true;
            this.updateVehicleInfo({
              netAppId: this.pairingAppId,
              endPoint: '',
              this: this,
              type: config.REPRO,
              // isRxswinUpdateFlow: Start 画面の車両通信で RxSWIN 更新完了ダイアログを表示させるフラグ
              // isCreateProject: システムAPI実施前にプロジェクト作成APIを投げるか否かのフラグ
              options: { isRxswinUpdateFlow: true, isCreateProject: true }
            });
          }
          return;
        }
        // VIN 入力画面が待機状態なら VIN 入力画面を表示
        if (this.hasStackedVinModal) {
          this.showVinInputModal();
          this.hasStackedVinModal = false;
          return;
        }
        // 車両通信ダイアログに復帰して監視再開
        if (this.vehicleStatus === config.POLLING_RUNNING && !this.isExitSequence) {
          this.showVehicleModal = true;
          this.$resumeInterval(this.vehicleWatcher);
        }
      }
    },

    closeModalQueue() {
      this.showModalQueueWarning = false;
      // Queue の先頭を削除
      modalQueue.shift();
    },

    async showVinInputModal() {
      // VIN と アプライドモデル設定画面を表示
      this.vinNumber = '';
      this.chassisNumber1 = '';
      this.chassisNumber2 = '';
      this.appliedModel = '';
      this.category = '';
      this.individualNumber = '';
      this.classificationList = [];
      this.selectedClassification = '';
      this.clearAlert();

      if (this.vehicleInfo.vehicle.vin.type === config.VEHICLEINFO_TYPE_CHASSISNUMBER) {
        // 車両番号が同一の場合は入力画面を表示せず、VIN 更新
        if (this.oldVehicleInfo) {
          // console.log("[old] : " + this.oldVehicleInfo.vehicle.vin.vin);
          // console.log("[new] : " + this.vehicleInfo.vehicle.vin.vin);
          if (this.vehicleInfo.vehicle.vin.vin === this.oldVehicleInfo.vehicle.vin.vin) {
            // 本APIの失敗はvehicleStatusに格納される
            // isCreateProject: システムAPI実施前にプロジェクト作成APIを投げるか否かのフラグ
            const apiParam = {
              netAppId: this.pairingAppId,
              this: this,
              options: { isCreateProject: this.vehicleInfo?.vehicle?.project?.id ? false : true },
              type: this.apiDestination
            };
            await this.runSystemApi(apiParam);
            return;
          }
        }
        // 前回取得の車両情報があればプリセット設定
        const chassisNumbers = vehicle.chassisNumberSplit(this.vehicleInfo.vehicle.vin.vin);
        this.chassisNumber1 = chassisNumbers[0];
        this.chassisNumber2 = chassisNumbers[1];
        this.appliedModel = this.vehicleInfo.vehicle.vin.applied_model || "";
        // アプライドモデルが未設定のときだけ、区分に前回の車両情報を反映させる。
        if (this.appliedModel === '') {
          this.selectedClassification = this.vehicleInfo.vehicle.spec.classification || "";
        }
        const classificationListTemp = this.vehicleInfo.vehicle.vin.classifications || [];
        classificationListTemp.unshift("");
        this.classificationList = classificationListTemp;
        this.isVehicleInspection = this.vehicleInfo.vehicle.vin.is_vehicle_inspection;
        this.selectedHiragana = this.vehicleInfo.vehicle.vin.hiragana ? this.vehicleInfo.vehicle.vin.hiragana : this.hiraganaList[0].name;
        this.selectedAreaName = this.vehicleInfo.vehicle.vin.area_name ? this.vehicleInfo.vehicle.vin.area_name : this.areaInfo ? this.areaInfo : this.areaNameList[0].name;
        this.individualNumber = this.vehicleInfo.vehicle.vin.individual_number || "";
        this.category = this.vehicleInfo.vehicle.vin.category || "";
      }
      this.$pauseInterval(this.vehicleWatcher);
      this.showVehicleModal = false;
      this.showVINModal = true;
    },

    callModalHiddenEvent() {
      this.startModalQueue();
    },

    clearWatcher() {
      this.processing = false;
      modalQueue = [];
      this.isModalQueueRunning = false;
      this.$stopInterval(this.vehicleWatcher);
    },

    exitFromConnection() {
      this.isExitSequence = true;
      this.clearWatcher();
      this.showModalQueueWarning = false;
      // 車両の電圧低下で車両情報取得をキャンセルした場合、CC優先権を破棄し、Start画面に戻る。
      this.leaveCCPriority();
    },

    async diagVehicleInfo() {
      // abortSequenceDll取得
      const isSuccess = await this.abortSequenceDll();
      if (!isSuccess) {
        this.processing = false;
        const errorInfo = {
          message: this.$t(api.getErrorMessageForCode(Error.INTERNAL_SERVER_ERROR)),
          behaviorType: handler.behaviorTypes.logout,
          validatorResult: null,
          other: null
        };
        this.showFailedMessage('message.error_vehicle_connect_title', errorInfo);
        return;
      }
      // TODO：本来は車両情報取得と完全に処理を分けて電圧を取得したいが、影響範囲が大きいためリリース前の修正は見送り
      // 今後、リプロサービスが停止して動作しない場合に診断のみ車両情報取得する場合は本処理を修正する必要がある。
      // 既に電圧取得済みだった場合は下記処理skip
      // if (this.voltage === null) {
      //   await this.updateVoltage({ netAppId: this.pairingAppId, instance: this, type: config.DIAG });
      // }

      // ダイアグの車両情報取得
      this.updateVehicleInfo({
        netAppId: this.pairingAppId,
        endPoint: '',
        this: this,
        type: config.DIAG,
        // isRxswinUpdateFlow: Start 画面の車両通信で RxSWIN 更新完了ダイアログを表示させるフラグ
        // isCreateProject: システムAPI実施前にプロジェクト作成APIを投げるか否かのフラグ
        options: { isRxswinUpdateFlow: false, isCreateProject: false }
      });

    },

    // メニュー画面遷移前処理
    async transitionMenuScreenHandler(systemMode) {

      this.showVehicleModal = true;

      const response = await this.getForDisplayMenu({
        pairingAppId: this.pairingAppId,
        systemMode: systemMode,
        operationScreen: this.operationScreen,
        modal: this,
        isFromHome: true
      });
      const error = response?.error;
      if (error) {
        this.showVehicleModal = false;
        if (error.causeType === handler.causeTypes.permissionError) {
          alert.showError(this, null, this.$t(errorMapping.getErrorMessageForCode(Error.USER_ACCESS_PERMISSION_ERROR)), () => {
            this.logout(this);
          });
        } else if (error.behaviorType === handler.behaviorTypes.logout) {
          this.logout(this);
        } else {
          alert.showError(this, null, this.$t('message.error_vehicle_connect_title'), () => {
            this.logout;
          });
        }
        return;
      }

      this.setSystemTblModalFlag(true);
      this.setProgress(100);
      await util.sleep(1000);
      // 車両情報取得のwait画面を終了
      this.showVehicleModal = false;
      // 正常に取得した情報を内部でキャッシュ
      this.cacheVehicleInfo(this.vehicleInfo);
      // システム画面へ遷移
      this.$router.push({ name: 'menu' });
    },

    // SSM5対象外車両の場合のMenu画面遷移処理
    async transitionMenuScreenExcludedVehicle(systemMode) {
      // NOTE: progressの値はapiDestinationの種類で制御されており（※computed参照）、
      // rprの場合はstate.vehicle.progressを2で割っているのため、100%にするために倍の200を設定している。
      this.setProgress(200);
      await util.sleep(1000);
      // リプログラミング機能が利用できる場合、以下の処理を行う
      if (this.isReproAvailable) {
        const param = {
          netAppId: this.pairingAppId,
          obj: this,
          isBothTable: authority.hasUnpublishedPermission(this.authGroup), 
          mode: systemMode,
          isSoldVehicle: this.vehicleInfo.is_sold_vehicle
        };
        await this.setNativeSystemTable(param);
        // 正常に取得した情報を内部でキャッシュ
        this.cacheVehicleInfo(this.vehicleInfo);
      }
      // 個車情報取得メニューを表示しない
      this.clearVehicleInformation();
      // システム画面へ遷移
      this.$router.push({ name: 'menu' });
    },
    getReproRegionList() {
      this.reproRegionList = [];
      REPRO_REGION_LIST.forEach((region) => {
        this.reproRegionList.push({
          text: this.$t(region.text), value: region.value
        });
      });
      return;
    },

    // CC優先権を取得する
    // 同一ユーザー/同一CCで利用する外部サービスと車両通信が競合する恐れがあるため
    // それらを回避するために Cloud Connector の優先権を制御する
    async enterCCPriority() {
      this.processing = true;
      const param = {
        type: "lock",
        service: "ssm5"
      };
      const enterCCResponse = await api.postCall(config.REPRO, `/netApps/${this.pairingAppId}/usagePriority`, param);
      this.processing = false;
      let res = null;
      handler.validate(handler.validateTypes.all, enterCCResponse, this, null, () => {
        if (enterCCResponse.data.status) {
          res = true;
        } else {
          alert.showError(this, null, this.$t('error.CLOUD_CONNECTOR_UNAVAILABLE'));
          res = false;
        }
      }, (result) => {
        // 処理が失敗したときのコールバック処理
        if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
      });
      // バリデーションが成功した場合の処理
      return res;
    },

    // CC優先権を破棄する
    // 同一ユーザー/同一CCで利用する外部サービスと車両通信が競合する恐れがあるため
    // それらを回避するために Cloud Connector の優先権を制御する
    async leaveCCPriority() {
      this.processing = true;
      const param = {
        type: "unlock",
        service: "ssm5"
      };
      const leaveCCResponse = await api.postCall(config.REPRO, `/netApps/${this.pairingAppId}/usagePriority`, param);
      this.processing = false;
      handler.validate(handler.validateTypes.all, leaveCCResponse, this, null, () => {
        // noop
      }, (result) => {
        // 処理が失敗したときのコールバック処理
        if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
      });
    }
  },

  mounted() {
    // VIN番号のアラート設定を初期化
    this.clearAlert();
    this.cacheDisplayReproTypeMode("campaign");

    // IMB情報を初期化
    this.getImbMenu({ "netAppId": "", "isTestMode": null });
    // MAC鍵情報を初期化
    this.getMacVisibility({ "netAppId": "", "isTestMode": null });
    // OBD情報を初期化
    this.clearObd();
    // 車両情報のみ自動取得処理を実施するかチェック
    const isAutoMode = utils.parseBoolean(this.isAuto);
    if (isAutoMode) {

      // Navigationに設定された「home」のパラメータを変更する
      const index = this.breadCrumbs.findIndex(item => item.name === 'home');
      if (index !== -1) {
        // 自動接続はOFFに設定する
        this.breadCrumbs[index].param.isAuto = false;
      }

      // 車両情報の自動取得を実施 
      this.startConnectionToVehicle();
      return;

    }

    // 自動接続状態の有無をチェック
    if (this.isSkipStart) {
      if (this.lastPairingNetAppId) {
        // クラウドコネクターに接続済みかチェック
        if (!this.pairingAppId) {
          this.connectToNetApp(this.lastPairingNetAppId, false);
          return;
        }
        else {
          // クラウドコネクターに接続済みの場合は車両情報取得に遷移する。
          this.startConnectionToVehicle();
          return;
        }
      }
      else {
        // 自動接続はOFFに設定しておく
        this.setIsSkipStart(false);
        // 前回接続したクラウドコネクターが無い場合は確認ダイアログを表示する。
        const messages = this.$t('message.message_not_found_cloud_connector');
        alert.showInfo(this, null, messages);
      }
    }
    // ミラーサイト環境かつ、メインサイトが稼働中（非メンテナンス状態）だった場合、車両取得情報およびCCダウンロードボタンを無効にする。
    this.buttonActivateFlg = (process.env.VUE_APP_BACKUP_TYPE && this.envActive === 'master');
  },

  created() {
    //CCの画像パスの初期値を設定
    this.setCcImageSrc(this.language);
    //JSONの読み出しをしてListに挿入
    this.areaNameList = this.readJsonFile(areaNameListJson);
    this.hiraganaList = this.readJsonFile(hiraganaListJson);
    // 診断プロジェクト一覧のキャッシュをクリア
    this.cacheDiagProjectList({});
    this.getReproRegionList();
    // デフォルトでお知らせを開いた状態にするため、お知らせの内容は予め取得しておく。
    this.updateNoticeInfo(this.language);
    // CCがクラウド接続中の状態でStart画面に戻ってきた場合、CC優先権を破棄する
    // Start画面の初回表示時は、この処理は通らない
    if (this.pairingAppId) {
      this.leaveCCPriority();
    }
  },

  beforeUnmount() {
    this.$stopInterval(this.pairingWatcher);
    this.$stopInterval(this.vehicleWatcher);
    modalQueue = [];
  },

  // i18nリソースの取得完了まで画面遷移しないようにする
  async beforeRouteLeave(to, from, next) {
    this.processing = true;
    await i18nResourceLoader.wait();
    this.processing = false;
    next();
  }
};